import { render, staticRenderFns } from "./m_jenis_lapak.vue?vue&type=template&id=05c12058&scoped=true&"
import script from "./m_jenis_lapak.vue?vue&type=script&lang=js&"
export * from "./m_jenis_lapak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c12058",
  null
  
)

export default component.exports